import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

const AdmissionBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const slides = [
    {
      id: 1,
      title: "🎓 Admission Open for 2026-27",
      description: "Enroll now for Classes 1-12 | Science, Commerce & Humanities",
      bgColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      cta: "Apply Now"
    },
    {
      id: 2,
      title: "✨ Limited Seats Available",
      description: "Small batch size of 10-15 students | IIT-ian faculty",
      bgColor: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      cta: "Book Free Demo"
    },
    {
      id: 3,
      title: "🏆 Early Bird Discount",
      description: "Register by March 2026 and get special discounts | Fee starting at ₹499",
      bgColor: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      cta: "Contact Us"
    }
  ];

  useEffect(() => {
    if (!isVisible) return;
    
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [isVisible, slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="relative overflow-hidden"
      style={{ 
        background: slides[currentSlide].bgColor,
        transition: 'background 0.5s ease'
      }}
    >
      <div className="container mx-auto px-4 py-6 relative">
        <div className="flex items-center justify-between">
          {/* Previous Button */}
          <button
            onClick={prevSlide}
            className="p-2 rounded-full bg-white/20 hover:bg-white/30 transition-colors backdrop-blur-sm"
            aria-label="Previous slide"
          >
            <ChevronLeft size={20} className="text-white" />
          </button>

          {/* Content */}
          <div className="flex-1 text-center px-4">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-2">
              {slides[currentSlide].title}
            </h2>
            <p className="text-white/90 text-sm md:text-base mb-3">
              {slides[currentSlide].description}
            </p>
            <a
              href="/contact"
              className="inline-block bg-white text-gray-900 px-6 py-2 rounded-full font-semibold text-sm hover:bg-gray-100 transition-colors"
            >
              {slides[currentSlide].cta}
            </a>
          </div>

          {/* Next Button */}
          <button
            onClick={nextSlide}
            className="p-2 rounded-full bg-white/20 hover:bg-white/30 transition-colors backdrop-blur-sm"
            aria-label="Next slide"
          >
            <ChevronRight size={20} className="text-white" />
          </button>

          {/* Close Button */}
          <button
            onClick={() => setIsVisible(false)}
            className="absolute top-2 right-2 p-1 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
            aria-label="Close banner"
          >
            <X size={18} className="text-white" />
          </button>
        </div>

        {/* Slide Indicators */}
        <div className="flex justify-center gap-2 mt-4">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 rounded-full transition-all ${
                index === currentSlide 
                  ? 'bg-white w-6' 
                  : 'bg-white/50 hover:bg-white/70'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdmissionBanner;
